import core from 'api/core';
import queryString from 'query-string';

export const getAllCount = (): Promise<any> => core.get(`/api/2/cart/all?count=true`).then(({data}) => data);

export const getAllPurchaseOrders = (): Promise<any> => core.get('/api/2/cart/all').then(({data}) => data);

export const deletePurchaseOrder = (poid: string, CSRFToken: string): Promise<any> =>
  core.post('/api/2/cart/mark-as-delete', queryString.stringify({poid, CSRFToken}));
